
















import { Component, Mixins, Watch } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import TheRcmdProductTemplate from '../basicRecommendation/TheRcmdProductTemplate.vue'
import TheRcmdProductMixin from '../basicRecommendation/TheRcmdProductMixin'
import RiderProduct from '@master/model/kyc-form/product/RiderProduct'

@Component({
  components: {
    TheRcmdProductTemplate
  }
})
export default class TheInsuranceProductModal extends Mixins(TheRcmdProductMixin) {
  addRider () {
    if (!this.mainBasicProduct.oid) {
      return this.uiService.alert.show({
        type: 'error',
        message: 'Please select a main insurance product before adding riders.'
      })
    }
    const newRider = new RiderProduct(this.riskRatingService, this.mainBasicProduct.clientIndex, this.mainBasicProduct.clientChoice)
    this.mainBasicProduct.riders.push(newRider)
  }

  deleteRider (event) {
    const { index } = event
    this.mainBasicProduct.riders.splice(index, 1)
  }

  get productFormStructure (): FormStructure<BasicProduct> {
    return [
      {
        label: 'Owner',
        key: 'clientIndex',
        classes: ['colspan'],
        options: this.ownerOptions.map(owner => {
          return {
            label: owner.name,
            value: owner.value
          }
        })
      },
      {
        label: 'Joint Owner',
        key: 'jointClientIndex',
        classes: ['colspan'],
        options: this.ownerOptions.filter(owner => owner.value !== this.mainBasicProduct.clientIndex).map(owner => {
          return {
            label: owner.name,
            value: owner.value
          }
        })
      },
      {
        label: 'Life Assured 1',
        key: 'lifeAssured',
        classes: ['colspan'],
        options: this.nameList
      },
      {
        label: 'Life Assured 2',
        key: 'lifeAssuredTwo',
        classes: ['colspan'],
        options: this.nameList
      },
      {
        label: 'Priority',
        key: 'priority',
        options: this.priorityOptionsMap,
        onChange: (oldVal, newVal) => {
          this.handlePriorityOnChange(this.mainBasicProduct, newVal)
        }
      },
      {
        label: 'Filtered By Needs',
        key: 'need',
        options: this.needsOptionsMap,
        onChange: (oldVal, newVal) => {
          // if issuer is not in the needs cover, should clear too
          const includedIssuer = this.getInsuranceIssuerWithProducts(newVal).find(issuer => issuer.value === this.mainBasicProduct.issuerOid)
          if (!includedIssuer) {
            this.mainBasicProduct.issuerOid = ''
          }
          this.handleNeedsOnChange(this.mainBasicProduct, newVal)
        }
      },
      {
        label: 'Issuer',
        key: 'issuerOid',
        classes: ['colspan'],
        options: this.getInsuranceIssuerWithProducts(this.mainBasicProduct.need),
        onChange: (oldVal, newVal) => {
          this.handleIssuerOnChange(newVal)
        }
      },
      {
        label: 'Product Name',
        key: 'oid',
        classes: ['colspan'],
        options: this.insuranceProductDisplayList.map(prod => {
          return { label: prod.name, value: prod.oid }
        }),
        onChange: (oldValue, newVal) => {
          if (!newVal) {
            this.mainBasicProduct.recommendedRiskProfile = undefined
          }
          this.updateSelectedProduct(newVal, this.insuranceProductDisplayList, this.mainBasicProduct)
        }
      },
      {
        label: 'Risk Rating',
        key: 'recommendedRiskProfileString',
        classes: ['colspan'],
        disabled: true
      },
      {
        label: 'Sum Assured ' + this.currencySymbol,
        key: 'sumAssured',
        type: 'currency'
      },
      {
        label: 'Premium Amount ' + this.currencySymbol,
        key: 'premiumAmount',
        type: 'currency',
        precision: 2
      },
      {
        label: 'Payment Mode',
        key: 'paymentMode',
        options: this.paymentModeOptions
      },
      {
        label: 'Policy Term',
        key: 'policyTerm'
      },
      {
        label: 'Premium Term',
        key: 'premiumTerm',
        type: 'number'
      },
      {
        label: 'Frequency',
        key: 'frequency',
        options: this.frequencyOptions
      }
    ]
  }

  handleIssuerOnChange (newVal: string) {
    if (!newVal) {
      return
    }
    this.updateInsurerName(newVal)
    // clear the product as issuer has change
    this.clearProductOidOnChange(this.mainBasicProduct)
  }

  getInsuranceIssuerWithProducts (need: string) {
    const issuerList = this.cdMetaList.retrieveIssuerFromProducts(this.productList.retrieveInsuranceProductList([need], []))
    // potential fix for ipad issues where it prepopulatest dropdown with the first option in the list
    const newIssuerList = issuerList.map(issuer => {
      return { label: issuer.companyShortName, value: issuer.oid }
    })
    newIssuerList.unshift({ label: '', value: '' })
    return newIssuerList
  }

  get insuranceProductDisplayList () {
    return this.productList.retrieveInsuranceProductList([this.mainBasicProduct.need], [this.mainBasicProduct.issuerOid])
  }

  // rider handler
  getRiderFormStructure (rider: RiderProduct): FormStructure<RiderProduct> {
    const riderProductList = this.getRiderProductList(rider)
    return [
      {
        label: 'Priority',
        key: 'priority',
        classes: ['colspan'],
        options: this.priorityOptionsMap,
        onChange: (oldVal, newVal) => {
          this.handlePriorityOnChange(rider, newVal)
        }
      },
      {
        label: 'Filtered by Need',
        key: 'need',
        options: this.needsOptionsMap,
        onChange: (oldVal, newVal) => {
          this.handleNeedsOnChange(rider, newVal)
        }
      },
      {
        label: 'Product Name',
        key: 'oid',
        options: riderProductList.map(rider => {
          return { label: rider.name, value: rider.oid }
        }),
        onChange: (oldVal, newVal) => {
          this.updateSelectedProduct(newVal, riderProductList, rider)
        }
      },
      {
        label: 'Sum Assured ' + this.currencySymbol,
        key: 'sumAssured',
        type: 'currency'
      },
      {
        label: 'Premium Amount ' + this.currencySymbol,
        key: 'premiumAmount',
        type: 'currency',
        precision: 2
      },
      {
        label: 'Frequency',
        key: 'frequency',
        options: this.frequencyOptions
      }
    ]
  }

  // rider
  getRiderProductList (rider) {
    return this.productList.retrieveRidersUsingFamilyCode(this.mainBasicProduct?.productFamilyCode, this.mainBasicProduct?.issuerOid, [rider.need])
  }

  defaultPriorityIfNotSet () {
    const isCurrentPriorityValid = this.priorityOptionsMap.find(priority => priority.value === this.mainBasicProduct.priority)
    if (!isCurrentPriorityValid) {
      // if selected priority is not included in this priority map, empty it, so that validation can prompt error
      if (this.mainBasicProduct.priority) {
        this.mainBasicProduct.priority = ''
      } else {
        // default to first of priority map
        this.mainBasicProduct.priority = this.priorityOptionsMap[0]?.value ?? ''
      }
    }
  }

  updateInsurerName (issuerOid: string) {
    const issuerName = this.getInsuranceIssuerWithProducts(this.mainBasicProduct.need).find(issuer => issuer.value === issuerOid).label
    this.mainBasicProduct.issuer = issuerName
    // had to update rider issuer name too
    if (this.mainBasicProduct.riders?.length > 0) {
      this.mainBasicProduct.riders.forEach(rider => {
        rider.issuer = issuerName
        rider.issuerOid = issuerOid
      })
    }
  }

  clearProductOidOnChange (model) {
    model.resetProduct()
    // remember to clear the riders too
    if (model.riders?.length > 0) {
      model.riders.forEach(rider => rider.resetProduct())
    }
  }

  mounted () {
    this.defaultPriorityIfNotSet()
    this.updateSelectedProduct(this.mainBasicProduct.oid, this.insuranceProductDisplayList, this.mainBasicProduct, false)
  }

  @Watch('saveOnClick')
  async saveProduct () {
    if (this.saveOnClick) {
      if (!this.mainBasicProduct.priority) {
        await this.uiService.alert.show({
          type: 'error',
          message: 'Priority field cannot be empty'
        })
        this.$emit('save', { validationPass: false, insuranceModal: undefined })
        return
      }
      const validRider = this.mainBasicProduct.riders.every(rider => rider.priority)
      if (!validRider) {
        await this.uiService.alert.show({
          type: 'error',
          message: 'Priority field in rider cannot be empty'
        })
        this.$emit('save', { validationPass: false, insuranceModal: undefined })
        return
      }
      this.$emit('save', { validationPass: true, insuranceModal: this.mainBasicProduct })
    }
  }
}
